import styled from "styled-components";
import { Container } from "../../styles/Container";

export const Wrapper = styled.div`
  height: 740px;
  margin: 0 auto;

  ${Container}
`;

export const Content = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
`;

export const Avatar = styled.img`
  width: 70%;
  border-radius: 50%;

  @media (min-width: 992px) {
    width: 50%;
  }
  @media (min-width: 1200px) {
    width: 35%;
  }
`;

export const Text = styled.div`
  padding: 2rem auto;
  text-align: center;

  h1 {
    font-size: 36px;
    font-weight: 400;
    margin: 0.5rem;
  }
  p {
    line-height: 1.75rem;
    font-weight: 300;
  }
`;
